import request from '@/config/axios'

/** 供应商状态：0启用 1停用 2黑名单 */
export const ProductSupplierStatus = {
  ENABLE: 0,
  DISABLE: 1,
  BLACKLIST: 2
} as const

/** 供应商分级：1战略 2核心 3普通 */
export const ProductSupplierTier = {
  STRATEGIC: 1,
  CORE: 2,
  NORMAL: 3
} as const

export const ProductSupplierTierOptions = [
  { label: '战略', value: ProductSupplierTier.STRATEGIC },
  { label: '核心', value: ProductSupplierTier.CORE },
  { label: '普通', value: ProductSupplierTier.NORMAL }
]

export const ProductSupplierStatusOptions = [
  { label: '启用', value: ProductSupplierStatus.ENABLE },
  { label: '停用', value: ProductSupplierStatus.DISABLE },
  { label: '黑名单', value: ProductSupplierStatus.BLACKLIST }
]

export interface SupplierVO {
  id?: number
  name: string
  contact?: string
  mobile?: string
  address?: string
  remark?: string
  tier: number
  status: number
  sort: number
  qualificationUrls?: string[]
  createTime?: Date
}

export const createSupplier = (data: SupplierVO) => {
  return request.post({ url: '/product/supplier/create', data })
}

export const updateSupplier = (data: SupplierVO) => {
  return request.put({ url: '/product/supplier/update', data })
}

export const deleteSupplier = (id: number) => {
  return request.delete({ url: `/product/supplier/delete?id=${id}` })
}

export const getSupplier = (id: number) => {
  return request.get({ url: `/product/supplier/get?id=${id}` })
}

export const getSupplierPage = (params: PageParam) => {
  return request.get({ url: '/product/supplier/page', params })
}

/** 仅启用，发品下拉 */
export const getSimpleSupplierList = () => {
  return request.get({ url: '/product/supplier/list-all-simple' })
}
